<template>
	<div class="content flex-center">
		<div class="box flex-column">
			<img src="@/assets/images/noVideo.png">
			<div class="text">即将开放，敬请期待</div>
		</div>
	</div>
</template>

<script setup>
	
</script>

<style lang="scss" scoped>
	.content{
		width:100%;
		.box{
			text-align:center;
			.text{
				margin-top:15px;
				font-size: 16px;
			}
		}
		
	}
</style>